import { createActions } from "@thewebops/admin-panel";

const actions = {
  downloadImportTemplate: createActions(`category/downloadImportTemplate`),
};

export default actions;
